module.exports = __webpack_public_path__ + "img/lingdan.920940d0.920940d0.png";